import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { GridRowModes } from "@mui/x-data-grid";
import CustomButton from "components/CustomButton";
import { Card, Container, Row } from "reactstrap";
import { masterServiceBaseUrl, putpost, putpost2 } from "services/http";

import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";

import AInput from "../../common/formFeilds/customInput/AInput";
import AButton from "../../common/form-fields-mui/AButton";
import APopover from "../../common/a-popover";
import {
  failureToast,
  successToast,
} from "../../common/utils/methods/toasterFunctions/function";
import { statusFilterOptions } from "../studentFinancials/paymentCollectionSetup/bankMaster/common";
import AToggleButtonGroup from "../../../../../components/AToggleButtonGroup/AToggleButtonGroup";

import TableContent from "./TableContent";
import PincodeFilters from "./PincodeFilters";

import { getData, isObjEmpty, NEW_EMPTY_ROW } from "./constants";

var _ = require("lodash");

const PincodeTable = (props) => {
  const history = useHistory();

  const {
    classArray,
    pagination,
    userPermissions,
    isSaveVisible,
    setisSaveVisible = () => {},
    fetchAllPincodeData,
    onPageChange,
    searchPincodeHandler,
    apiloader,
  } = props;

  const [tableDataKey, settableDataKey] = useState("tableDataKey");
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [searchByPincode, setSearchByPincode] = useState("");
  const [payload, setPayload] = useState({
    pincodeGstCode: "",
    status: "",
    countryId: "",
    stateId: "",
    districtId: "",
    cityId: "",
    effectiveDate: "",
    // statrtDate: "",
    // endDate: "",
  });
  const [filterCount, setFilterCount] = useState(0);

  const [rowData, setRowData] = useState(classArray);
  const [rowForm, setRowForm] = useState({});
  const [rowModesModel, setRowModesModel] = useState({});

  useEffect(() => {
    setRowData(classArray);
  }, [classArray]);

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "countryId" },
    }));

    setRowForm(form);
  };

  const stopEditing = (id) => {
    const currForm = { ...rowForm };

    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const saveAll = (rowId) => {
    if (!rowForm["countryId"]) {
      failureToast("Please enter the value of Country");
      return;
    } else if (!rowForm["stateId"]) {
      failureToast("Please enter the value of State");
      return;
    } else if (!rowForm["districtId"]) {
      failureToast("Please enter the value of District");
      return;
    } else if (!rowForm["cityId"]) {
      failureToast("Please enter the value of City");
      return;
    } else if (
      rowForm["pincodeGstCode"] === null ||
      !rowForm["pincodeGstCode"].trim()
    ) {
      failureToast("Please enter the value of Pincode");
      return;
    } else if (
      rowForm["pincodeDesc"] === null ||
      !rowForm["pincodeDesc"].trim()
    ) {
      failureToast("Please enter the value of Description");
      return;
    } else if (
      rowForm["pincodeDispValue"] === null ||
      !rowForm["pincodeDispValue"].trim()
    ) {
      failureToast("Please enter the Display Value");
      return;
    }

    const modifiedPayload = {
      status: rowForm.status,
      pincodeDesc: rowForm.pincodeDesc,
      pincodeDispValue: rowForm.pincodeDispValue,
      pincodeGstCode: rowForm.pincodeGstCode,
      salesforceId: rowForm.salesforceId,
      websiteId: rowForm.websiteId,
      countryId: rowForm.countryId,
      stateId: rowForm.stateId,
      districtId: rowForm.districtId,
      cityId: rowForm.cityId,
    };

    if (rowForm?.isNew) {
      putpost(
        masterServiceBaseUrl + "/pincode/createPincode",
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          fetchAllPincodeData();
          setStateList([]);
          setDistrictList([]);
          setCityList([]);
          stopEditing(rowId);
        },
        (data) => {
          failureToast(data["message"]);
        },
        modifiedPayload,
        "post"
      );
    } else {
      putpost(
        masterServiceBaseUrl + "/pincode/updatePincode/" + rowId,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          fetchAllPincodeData();
          setStateList([]);
          setDistrictList([]);
          setCityList([]);
          stopEditing(rowId);
        },
        (data) => {
          failureToast(data["message"]);
        },
        modifiedPayload,
        "put"
      );
    }
  };

  const newRow = () => {
    if (!isObjEmpty(rowForm)) {
      failureToast("Please Delete or Save current changes");
    } else {
      let randomId = uuidv4();
      let emptyRow = {
        ...NEW_EMPTY_ROW,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
      setisSaveVisible(true);
    }
  };

  const handleCancelClick = async (params) => {
    stopEditing(params?.id);

    if (params?.row?.isNew) {
      setRowData(classArray);
      setRowForm({});
    }
  };

  const deleteRow = (rowId) => {
    if (window.confirm("Are you sure you want to delete this Pincode?")) {
      putpost2(
        masterServiceBaseUrl + "/pincode/deletePincode/" + rowId,
        (data) => {
          successToast(data["message"]);

          setisSaveVisible(false);

          const filteredList = classArray.filter((obj) => obj.id !== rowId);
          props.setclassArray(filteredList);

          props.refreshList();
          settableDataKey(new Date().getMilliseconds());
        },
        (data) => {
          failureToast(data["message"]);
        },
        "Delete"
      );
    }
  };

  const handleSearchPincode = () => {
    const newFilterObj = { ...payload, pincodeGstCode: searchByPincode };
    setPayload(newFilterObj);
    searchPincodeHandler(newFilterObj);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) handleSearchPincode();
  };

  const statusFilterChangeHandler = (status) => {
    const newFilterObj = {
      ...payload,
      status: status === "ALL" ? "" : status,
    };

    setRowForm({});
    setPayload(newFilterObj);
    searchPincodeHandler(newFilterObj);
  };

  const applyFilters = (filterForm) => {
    const newFilterObj = {
      ...payload,
      ...filterForm,
    };

    setPayload(newFilterObj);
    searchPincodeHandler(newFilterObj);
  };

  const handlePageChange = (page) => {
    onPageChange(payload, page);
  };

  const updateStateOptions = (countryId) => {
    setStateList([]);
    setDistrictList([]);
    setCityList([]);
    getData(
      `${masterServiceBaseUrl}/state/getStateByCountry/${countryId}`,
      setStateList,
      "state"
    );
  };

  const updateDistrictOptions = (stateId) => {
    setDistrictList([]);
    setCityList([]);
    getData(
      `${masterServiceBaseUrl}/district/getDistrictByState/${stateId}`,
      setDistrictList,
      "district"
    );
  };

  const updateCityOptions = (districtId) => {
    getData(
      `${masterServiceBaseUrl}/city/getCityByDistrict/${districtId}`,
      setCityList,
      "city"
    );
  };

  return (
    <>
      <Container className="mt-3" fluid>
        <Row>
          <div className="col">
            <Card>
              <div className="border-0 p-4">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <div
                    className={`d-flex align-items-center`}
                    style={{ height: "min-content" }}
                  >
                    <BackIcon
                      className="mr-2 large-text"
                      onClick={() => history.goBack()}
                    />
                    <div className="heading-3 color-black-60 text-bold">
                      Pincode Master
                    </div>
                  </div>

                  {/* FILTERS */}
                  <div className="d-flex justify-content-center align-items-center">
                    <AInput
                      placeholder={`Search by pincode`}
                      style={{ minWidth: "250px", height: "28px" }}
                      rightSearchIcon
                      crossIcon
                      value={searchByPincode}
                      handler={(value) => setSearchByPincode(value)}
                      onKeyDown={(e) => onKeyDown(e)}
                      crossHandler={() => {
                        setSearchByPincode("");
                        setPayload({ ...payload, pincodeGstCode: "" });
                        fetchAllPincodeData();
                      }}
                      searchIconClickHandler={handleSearchPincode}
                      disabled={!isObjEmpty(rowForm)}
                    />

                    <div className="ml-3" style={{ gap: "10px" }}>
                      <AToggleButtonGroup
                        options={statusFilterOptions}
                        defaultSelected={"ALL"}
                        allowDeselect={false}
                        changeHandler={statusFilterChangeHandler}
                        containerProps={{ disabled: !isObjEmpty(rowForm) }}
                      />
                    </div>

                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ columnGap: "20px" }}
                    >
                      <APopover
                        buttonComponent={(onClick, styles) => (
                          <AButton
                            className="tiny-semi-bold color-dark"
                            onClick={onClick}
                            updatedStyle={{
                              minWidth: "61px",
                              ...(filterCount > 0
                                ? {
                                    border: "1px solid #00B0F5",
                                    color: "#00B0F5",
                                  }
                                : styles),
                            }}
                            disabled={!isObjEmpty(rowForm)}
                          >
                            Filters {filterCount > 0 && <>( {filterCount} )</>}
                          </AButton>
                        )}
                        menuComponent={(closeForm) => (
                          <>
                            <PincodeFilters
                              applyFilters={applyFilters}
                              closeForm={closeForm}
                              payload={payload}
                              filterCount={filterCount}
                              setFilterCount={setFilterCount}
                              countryList={props.countryList}
                              stateList={stateList}
                              updateStateOptions={updateStateOptions}
                              districtList={districtList}
                              updateDistrictOptions={updateDistrictOptions}
                              cityList={cityList}
                              updateCityOptions={updateCityOptions}
                            />
                          </>
                        )}
                        maxHeight={"calc(100vh - 250px)"}
                      />
                    </div>

                    <CustomButton
                      // disabled={isSaveVisible}
                      className={
                        "mb-0" + isSaveVisible ? " btn-dark cursor-gray" : null
                      }
                      content={"New Pincode"}
                      permissionType={"C"}
                      icon={true}
                      onClick={() => {
                        newRow();
                      }}
                      forTable
                      permissionSet={userPermissions}
                    />
                  </div>

                  {/* FILTERS END HERE*/}
                </div>
              </div>

              <div id="questionTable" className="table-responsive ">
                <TableContent
                  rowData={rowData}
                  rowForm={rowForm}
                  setRowForm={setRowForm}
                  countryList={props.countryList}
                  allStateList={props.stateList}
                  stateList={stateList}
                  updateStateOptions={updateStateOptions}
                  allDistrictList={props.districtList}
                  districtList={districtList}
                  updateDistrictOptions={updateDistrictOptions}
                  updateCityOptions={updateCityOptions}
                  allCityList={props.cityList}
                  cityList={cityList}
                  saveAll={saveAll}
                  userPermissions={userPermissions}
                  pagination={pagination}
                  deleteRow={deleteRow}
                  onPageChange={handlePageChange}
                  loader={apiloader}
                  setclassArray={props?.setclassArray}
                  rowModesModel={rowModesModel}
                  startEditing={startEditing}
                  stopEditing={stopEditing}
                  handleCancelClick={handleCancelClick}
                />
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
export default PincodeTable;
